(function () {
  var selectors = [
    '.template-index .product-card',
    '.template-index .blog-card',
    '.template-index .custom__item',
    '.template-index .coach-section > *',
    '.template-index .kc-newsletter__card',
    '.template-index .kc-ig__card',
    '.template-product .kc-trailer__results',
    '.template-product .kc-trailer__frame',
    '.template-product .kc-preview__card',
    '.template-product .kc-offers__card',
    '.template-product .kc-program-fit__card',
    '.template-product .kc-program-fit__problem-card',
    '.template-product .kc-curriculum__group',
    '.template-product .kc-faq__item',
    '.template-product .kc-cta-buy__box',
    '.template-product .kc-cta-buy__help',
    '.template-product .product-card',
    '.template-collection .product-card'
  ];

  function initReveal(root) {
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var items = Array.prototype.slice.call(root.querySelectorAll(selectors.join(',')));

    if (!items.length) return;

    items.forEach(function (item, index) {
      if (item.hasAttribute('data-kc-uplift-reveal')) return;
      item.setAttribute('data-kc-uplift-reveal', '');
      item.style.setProperty('--kc-reveal-delay', Math.min(index % 6, 5) * 55 + 'ms');
    });

    if (reduceMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function init() {
    initReveal(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initReveal(event.target || document);
  });
})();
